"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharCount = void 0;
var char_count_1 = require("./char-count");
Object.defineProperty(exports, "CharCount", { enumerable: true, get: function () { return char_count_1.CharCount; } });
//# sourceMappingURL=index.js.map